
export const baseUrlObj = {
  "roles" : "/role-types",
  "patient": "/logged-in-user",
  "doctor": "/doctor",
  "care-admin": "/care-admin",
  "super_admin": "/super-admin",
  "client-admin": "/corporate-admin"
};

export const formats = {
  UTC: "YYYY-MM-DD hh:mm:ss",
  DATE_TIME_1: 'DD MMM YYYY hh:mm A', // 24 Apr 2022 04:03 PM
  DATE_TIME_2: 'DD MMMM YYYY hh:mm A', // 24 April 2022 04:03 PM
  DATE_TIME_3: 'DD MMM YYYY hh:mm A', // 24 Apr 2022 04:03 PM
  DATE_TIME_4: 'Do MMM YYYY, hh:mm A', // 24th Apr 2022, 04:03 PM
  DATE_TIME_5: 'Do MMMM YYYY, hh:mm A', // 24th April 2022, 04:03 PM
  DATE_TIME_6: 'Do MMMM YYYY hh:mm A', // 24th Aprril 2022 04:03 PM
  DATE_TIME_7: 'Do MMM YYYY | hh:mm A',// 24th Apr 2022 | 04:00 PM
  DATE_1: 'DD/MM/YYYY', // 24/04/2022
  DATE_2: 'DD-MM-YYYY', // 24-04-2022
  DATE_3: 'Do MMMM YYYY', // 24th April 2022
  DATE_4: 'Do MMM YYYY', // 24th Apr 2022
  DATE_14: 'DD MMM YYYY',// 24 Apr 2022
  DATE_13: 'Do-MMM-YYYY', // 24-Apr-2022
  DATE_5: 'Do MMMM', // 24th April
  DATE_6: 'MMM DD', // Apr 24
  DATE_7: 'MMMM DD', // April 24
  DATE_8: 'MMMM YYYY', // April 2022
  DATE_9: 'DD MMMM YYYY', // April 2022
  DATE_10: 'DD', //24
  DATE_11: 'YYYY MM DD', // 2022 02 25
  DATE_12: 'YYYY-MM-DD', // 2022-02-25
  DAY_1: 'dddd', //Sunday
  DAY_2: 'ddd', //Sun
  MONTH_1: 'MM', //02 
  MONTH_2: 'MMM', //Apr
  MONTH_3: 'MMMM', //April
  YEAR_1: 'YYYY', //2022
  YEAR_2: 'YY', //22
  TIME_1: 'hh:mm A', // 04:03 PM
  TIME_2: 'hh:mm:ss A', // 04:03:35 PM
  TIME_3: 'HH:mm', // 13:03
  TIME_4 : 'hh:mm A on DD-MMM-YYYY (dddd) ' ,
  TIME_5: 'hh:mm A',
  TIME_SEC_1: 'HH:mm:ss'
}

export const careAdminTickets = [
  { "label": "All", value: "all" },
  { "label": "Request For Treatment", "value": "request_for_treatment" },
  { "label": "Followup After Consultation", "value": "followup_after_appointment" },
  { "label": "Patient Appointment Reminder", "value": "patient_appointment_reminder" },
  { "label": "Patient Payment Reminder", "value": "patient_payment_reminder" },
  { "label": "Patient Rescheduling", "value": "patient_reschedule" },
  { "label": "Doctor Rescheduling", "value": "doctor_reschedule" },
  { "label": "Cancel Appointment", "value": "patient_cancel" },
  { "label": "CareTeam Assignment", "value": "care_team_assignment" },
  { "label": "Referral Assignment", "value": "referral_assignment" }
]

export const anxiety_levels = [
  {
    startValue: 0,
    fill: '#4caf51',
    label: 'Minimal',
  },
  {
    startValue: 6,
    fill: '#81c783',
    label: ' Mild ',
  },
  {
    startValue: 10,
    fill: '#ffb74d',
    label: 'Moderate',
  },
  {
    startValue: 14,
    fill: '#d84316',
    label: 'Moderately Severe',
  },
  {
    startValue: 18,
    fill: '#bf360d',
    label: 'Severe',
  },
];

export const depression_levels = [
  {
    startValue: 0,
    fill: '#4caf51',
    label: 'Minimal',
  },
  {
    startValue: 5,
    fill: '#81c783',
    label: ' Mild ',
  },
  {
    startValue: 10,
    fill: '#ffb74d',
    label: 'Moderate',
  },
  {
    startValue: 15,
    fill: '#d84316',
    label: 'Moderately Severe',
  },
  {
    startValue: 20,
    fill: '#bf360d',
    label: 'Severe',
  },
];



export const igd_levels = [
  {
    startValue: 0,
    fill: '#4caf51',
    label: 'Minimal',
  },
  {
    startValue: 4,
    fill: '#81c783',
    label: 'Mild',
  },
  {
    startValue: 8,
    fill: '#ffb74d',
    label: 'Moderate',
  },
  {
    startValue: 12,
    fill: '#d84316',
    label: 'Moderately Severe',
  },
  {
    startValue: 16,
    fill: '#bf360d',
    label: 'Severe',
  },
];

export const adhd_levels = [
  {
    startValue: 0,
    fill: '#4caf51',
    label: 'Minimal',
  },
  {
    startValue: 4,
    fill: '#81c783',
    label: 'Mild',
  },
  {
    startValue: 8,
    fill: '#ffb74d',
    label: 'Moderate',
  },
  {
    startValue: 12,
    fill: '#d84316',
    label: 'Moderately Severe',
  },
  {
    startValue: 16,
    fill: '#bf360d',
    label: 'Severe',
  },
];

export const ocd_levels = [
  {
    startValue: 0,
    fill: '#4caf51',
    label: 'Minimal',
  },
  {
    startValue: 4,
    fill: '#81c783',
    label: 'Mild',
  },
  {
    startValue: 8,
    fill: '#ffb74d',
    label: 'Moderate',
  },
  {
    startValue: 12,
    fill: '#d84316',
    label: 'Moderately Severe',
  },
  {
    startValue: 16,
    fill: '#bf360d',
    label: 'Severe',
  },
];